import styles from './popularBrands.scss';
import { Section } from 'components/Section';
import Image from 'components/Shared/Image';
import { Cell, Grid } from 'components/Grid';
import connect from 'components/Shared/connect';
import { isHuge, isDesktop } from 'components/Shared/responsive';
import { PopularBrandsBlock } from 'models/PopularBrandsBlock';
import { ShowMore } from './ShowMore';
import { rm, hasElements, NO_ELEMENT } from 'utils';
import { NotifyLink } from 'components/Shared/NotifyLink';
import cn from 'classnames';

const IMAGE_WIDTH = 150;
const IMAGE_HEIGHT = 75;

const AMOUNT_OF_BRANDS_LARGE = 7;
const AMOUNT_OF_BRANDS_SMALL = 8;

export const _PopularBrands = ({ isDesktop, brands, isHuge, url, ...props }: MergedProps) => {
  if (!hasElements(brands)) {
    return NO_ELEMENT;
  }

  const isLarge = isDesktop || isHuge;

  const amountToRender = isLarge ? AMOUNT_OF_BRANDS_LARGE : AMOUNT_OF_BRANDS_SMALL;
  const data = brands.slice(0, amountToRender);

  const content = data.map(({ title, url, brandImage, ticket }) => (
    <Cell className={cn(styles.pictureContainer, { [styles.flex]: isHuge })} key={title}>
      <NotifyLink ticket={ticket} url={url}>
        <Image
          key={title}
          height={IMAGE_HEIGHT}
          width={IMAGE_WIDTH}
          {...brandImage}
          paddingBottom
          wrapperClassName={styles.image}
        />
      </NotifyLink>
    </Cell>
  ));

  const showMoreAppearance = isHuge ? 'secondary' : isDesktop ? 'tertiary' : 'primary';

  const showMore = (
    <ShowMore title={rm('show_all_brands')} href={url} appearance={showMoreAppearance} />
  );

  return (
    <Section className={styles.section} {...props}>
      {isHuge ? (
        <div className={styles.largeScreen}>
          <div className={styles.contentContainer}>{content}</div>
          {showMore}
        </div>
      ) : (
        <Grid
          gutters="medium"
          huge="9"
          desktop="7"
          tablet="4"
          phone="2"
          className={styles.gridMargin}
        >
          {content}
          <Cell huge="6" tablet="1" phone="1" className={styles.buttonCell}>
            {showMore}
          </Cell>
        </Grid>
      )}
    </Section>
  );
};

interface MergedProps extends PopularBrandsBlock {
  isDesktop: boolean;
  isHuge: boolean;
}

export const PopularBrands = connect<MergedProps, PopularBrandsBlock>(state => ({
  isDesktop: isDesktop(state),
  isHuge: isHuge(state)
}))(_PopularBrands);
